<template>
  <div class="slide">
    <h3 v-if="text" class="slidecaption" v-html="text"></h3>
    <img
      v-for="file in files"
      :key="file.filename"
      :src="file.url"
      :srcset="file.srcset"
      sizes="90vw"
    />
  </div>
</template>

<script setup>
import { textToHtml, openLinksOutside } from '@/utils'

const props = defineProps({
  slide: { type: Object, required: true },
  images: { type: Array, default: () => [] },
})

const text = computed(() => openLinksOutside(textToHtml(props.slide?.text)))

const files = computed(() => {
  if (Array.isArray(props.slide?.files) && props.slide.files.length) {
    return props.slide.files;
  }
  const names = String(props.slide?.images || '')
    .split(',')
    .map((name) => name.trim())
    .filter(Boolean);
  return names
    .map((name) => props.images.find((image) => image.filename === name))
    .filter(Boolean);
})
</script>
